import NOTIFICATIONS_API from 'api/notifications/v1'
import i18next from 'i18next'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import i18n, { ensureAuthorizedShellI18nLoaded, ensureI18nNamespacesLoaded } from 'i18nProduct'
import { notificationSetCounters, notificationShow } from 'modules/Notifications/actions'
import {
  FETCH_NOTIFICATIONS,
  SET_NOTIFICATIONS,
} from 'modules/Recommendations/Audits/store/types'
import { FETCH_TICKETS_COUNTER, SET_I18N, SET_TICKETS_COUNTER } from 'modules/App/types'
import { selectAppUser } from 'modules/App/store/selectors'
import { UPDATE_USER_LOCALE } from 'modules/User/Profile/store/types'

export function* updateLangData(action) {
  const nextLocale = action?.payload?.i18n

  if (!nextLocale) {
    return
  }

  global.__localeId__ = nextLocale

  // Ensure current route namespaces exist for target locale before switching language.
  const user = yield select(selectAppUser)

  yield call(ensureI18nNamespacesLoaded, {
    pathname: global.location.pathname,
    routePath: global.location.pathname,
    locale: nextLocale,
  })

  if (user?.id) {
    yield call(ensureAuthorizedShellI18nLoaded, { locale: nextLocale })
  }

  yield call([i18n, i18n.changeLanguage], nextLocale)

  yield put({
    type: UPDATE_USER_LOCALE,
    payload: { locale: nextLocale },
  })
}

export function* fetchTicketsCounter() {
  const {
    app: { ticketsCounter, i18n },
    notifications: {
      counters: { ticket: ticketCounter = 0 },
    },
  } = yield select((state) => state)
  const prevTicketCounter = ticketCounter ?? ticketsCounter

  try {
    const { response, error } = yield call(NOTIFICATIONS_API.fetch, {
      params: { types: ['ticket'] },
    })

    if (error) {
      throw error
    }

    if (response?.data) {
      const count = response.data[0]?.count || 0

      if ((count > prevTicketCounter || prevTicketCounter === undefined) && count > 0) {
        yield put(
          notificationShow({
            type: 'success',
            message: i18next.t('common::notifications.tickets_updated', {
              i18n,
            }),
          }),
        )
      }

      yield put({
        type: SET_TICKETS_COUNTER,
        payload: count,
      })
      yield put(
        notificationSetCounters({
          ticket: count,
        }),
      )
    }
  } catch (error) {
    console.logXHR(error)
  }
}

export function* fetchRecommendationCounters() {
  try {
    const { response, error } = yield call(NOTIFICATIONS_API.fetch, {
      params: { types: ['audit', 'campaign_recommendation', 'benchmark'] },
    })

    const data = response?.data || []

    if (error) {
      throw error
    }

    const audit = data?.find?.((item) => item.type === 'audit')?.count ?? 0
    const recommendation =
      data?.find?.((item) => item.type === 'campaign_recommendation')?.count ?? 0
    const benchmark = data?.find?.((item) => item.type === 'benchmark')?.count ?? 0

    yield put(
      notificationSetCounters({
        audit,
        recommendation,
        benchmark,
      }),
    )
    yield put({
      type: SET_NOTIFICATIONS,
      payload: { audit, recommendation, benchmark },
    })
  } catch (error) {
    console.logXHR(error)
  }
}

export function* updateDrawerState() {}

export function* Sagas() {
  yield takeLatest(SET_I18N, updateLangData)
  yield takeLatest(FETCH_TICKETS_COUNTER, fetchTicketsCounter)
  yield takeLatest(FETCH_NOTIFICATIONS, fetchRecommendationCounters)
}
